var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActionBuy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 9.16536V12.4987M15 7.4987V10.832M14.1667 3.33203C16.2073 3.33203 17.3109 3.64433 17.8601 3.88657C17.9332 3.91883 17.9698 3.93496 18.0753 4.03567C18.1386 4.09605 18.2541 4.27319 18.2838 4.35544C18.3333 4.49265 18.3333 4.56765 18.3333 4.71765V13.6747C18.3333 14.432 18.3333 14.8106 18.2198 15.0052C18.1042 15.2032 17.9928 15.2953 17.7766 15.3714C17.5641 15.4462 17.135 15.3637 16.2768 15.1988C15.6762 15.0834 14.9638 14.9987 14.1667 14.9987C11.6667 14.9987 9.16667 16.6654 5.83333 16.6654C3.79274 16.6654 2.68906 16.3531 2.1399 16.1108C2.06677 16.0786 2.0302 16.0624 1.92467 15.9617C1.86141 15.9013 1.74593 15.7242 1.71623 15.642C1.66667 15.5047 1.66667 15.4297 1.66667 15.2797L1.66667 6.32274C1.66667 5.56544 1.66667 5.18678 1.78023 4.99215C1.89575 4.79417 2.00716 4.70213 2.22338 4.62604C2.43595 4.55124 2.86503 4.63368 3.72319 4.79857C4.32385 4.91398 5.03623 4.9987 5.83333 4.9987C8.33333 4.9987 10.8333 3.33203 14.1667 3.33203ZM12.0833 9.9987C12.0833 11.1493 11.1506 12.082 10 12.082C8.84941 12.082 7.91667 11.1493 7.91667 9.9987C7.91667 8.8481 8.84941 7.91536 10 7.91536C11.1506 7.91536 12.0833 8.8481 12.0833 9.9987Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionBuy);
export default __webpack_public_path__ + "static/media/action-buy.0eee9f5a0a17f3109dfb1e91811c2fa8.svg";
export { ForwardRef as ReactComponent };